import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IExposureValueBatchRequest } from "../interface/entuba/exposure/IExposureValueBatchRequest";
import { IEntubaExposureResponse } from "../interface/entuba/exposure/IEntubaExposureResponse";
import { IEntubaExposureDetailResponse } from "../interface/entuba/exposure/IEntubaExposureDetailResponse";

enum EntubaExposureServiceEnum {
  getAll = "/",
  getDetail = "",
  start = "/start"
}

export default class EntubaExposureService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/entuba/exposure");
  }

  public getAll = async (): Promise<IEntubaExposureResponse[]> => await this.GET(EntubaExposureServiceEnum.getAll);
  public getDetail = async (id: number): Promise<IEntubaExposureDetailResponse> => await this.GET(`${EntubaExposureServiceEnum.getDetail}/${id}`);
  public startEntubaExposure = async (data: IExposureValueBatchRequest) => await this.PUT(EntubaExposureServiceEnum.start, data);

}
